import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Link, Text } from '@beef/ui-kit';
import { Title } from "../Title";
import { IconArrowSmall } from "../../assets/IconArrowSmall";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var LegalInfo = /*#__PURE__*/memo(function (_ref) {
  var title = _ref.title,
    text = _ref.text,
    link = _ref.link;
  return /*#__PURE__*/React.createElement("div", {
    "data-t-id": "components-LegalInfo"
  }, title && /*#__PURE__*/React.createElement(Title, null, title), /*#__PURE__*/React.createElement("div", {
    className: cn('text')
  }, text && /*#__PURE__*/React.createElement(Text, {
    color: "grey50",
    size: "size6-r"
  }, text)), (link === null || link === void 0 ? void 0 : link.href) && /*#__PURE__*/React.createElement("div", {
    className: cn('link')
  }, /*#__PURE__*/React.createElement(Link, {
    href: link.href,
    isNoUnderline: true,
    rightIcon: /*#__PURE__*/React.createElement(IconArrowSmall, {
      className: cn('link-arrow')
    }),
    size: "size6-m",
    variant: "light"
  }, link.text || 'Перейти')));
});
export { LegalInfo };